// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__9LS-n","container":"Footer_container__viTkF","switch":"Footer_switch__Yesiv","slider":"Footer_slider__vXdT-"};